/* * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights
Reserved. * * Licensed under the Apache License, Version 2.0 (the "License").
You may not use this file except in compliance with * the License. A copy of the
License is located at * * http://aws.amazon.com/apache2.0/ * * or in the
"license" file accompanying this file. This file is distributed on an "AS IS"
BASIS, WITHOUT WARRANTIES OR * CONDITIONS OF ANY KIND, either express or
implied. See the License for the specific language governing permissions * and
limitations under the License. */

<template>
  <div class="forgot-password-container">
    <div class="logo"><img src="@/assets/logo.png" /></div>
    <!-- <div class="title">ログインできない場合</div> -->
    <validation-observer ref="obs" v-slot="ObserverProps">
      <div>
        <!-- <amplify-username-field 
        v-bind:usernameAttributes="usernameAttributes" 
        v-on:username-field-changed="usernameFieldChanged">
        </amplify-username-field> -->
        <div v-if="!sent" class="form-input">
          <div class="label">メールアドレス</div>
          <input
            v-model="username"
            type="text"
            autofocus
            v-on:keyup="usernameChanged"
            v-on:input="username = $event.target.value"
          />
        </div>
        <div v-if="sent" class="form-input">
          <div class="label">メールに送られた検証コードを入力してください</div>
          <ValidationProvider rules="required" v-slot="ProviderProps">
            <input v-model="code" type="text" autofocus />
            <div class="input-note validation-error" v-if="ProviderProps.invalid">
              {{ ProviderProps.errors[0] }}
            </div>
          </ValidationProvider>
          <!-- <div class="input-note">受信した検証コードを入力してください。</div> -->
        </div>
        <div v-if="sent" class="form-input">
          <div class="label">新しいパスワードを入力してください</div>
          <ValidationProvider rules="required|complexPassword" v-slot="ProviderProps">
            <input v-model="password" type="password" autofocus />
            <div class="input-note" :class="{ 'validation-error': ProviderProps.invalid }">
              アルファベット大文字、小文字、数字をそれぞれ1文字以上含む、8文字以上で入力してください
            </div>
          </ValidationProvider>
        </div>
      </div>

      <div class="actions" :class="{ disable: sending }">
        <div class="submit">
          <div
            class="button"
            v-if="!sent"
            v-on:click="submit"
            :disabled="!forgotPwUsername"
          >
            検証コードを送信
          </div>
          <div
            class="button"
            :class="{ disable: ObserverProps.invalid }"
            v-if="sent"
            v-on:click="verify"
            :disabled="!forgotPwUsername"
          >
            送信
          </div>
        </div>
        <div class="nav">
          <a v-if="!sent" v-on:click="signIn">戻る</a>
          <a v-if="sent" v-on:click="submit">検証コードを送信し直す</a>
        </div>
      </div>
    </validation-observer>
    <div class="error" v-if="error">
      {{ error }}
    </div>
  </div>
</template>

<script>
// import AmplifyEventBus from '../../events/AmplifyEventBus';
import { AmplifyEventBus } from "aws-amplify-vue";
// import * as AmplifyUI from '@aws-amplify/ui';
// import Vue from 'vue';
// import UsernameField from './UsernameField';
// import { auth } from '../../assets/data-test-attributes';

// Vue.component('amplify-username-field', UsernameField);

import ErrorMessage from "@/mixins/errormessages";

export default {
  name: "ForgotPassword",
  props: ["forgotPasswordConfig", "usernameAttributes"],
  mixins: [ErrorMessage],
  data() {
    return {
      username: "",
      code: "",
      password: "",
      error: "",
      sent: false,
      logger: {},
      // amplifyUI: AmplifyUI,
      forgotPwUsername: "",
      // auth
      sending: false,
    };
  },
  computed: {
    options() {
      const defaults = {
        header: this.$Amplify.I18n.get("Reset your password"),
      };
      return Object.assign(defaults, this.forgotPasswordConfig || {});
    },
  },
  mounted() {
    this.logger = new this.$Amplify.Logger(this.$options.name);
  },
  methods: {
    submit: function() {
      this.sending = true;
      this.$Amplify.Auth.forgotPassword(this.forgotPwUsername)
        .then(() => {
          this.sending = false;
          this.sent = true;
          this.logger.info("forgotPassword success");
        })
        .catch((e) => {
          this.sending = false;
          this.setError(e);
        });
    },
    verify: function() {
      this.sending = true;
      this.$Amplify.Auth.forgotPasswordSubmit(
        this.forgotPwUsername,
        this.code,
        this.password
      )
        .then(() => {
          this.sending = false;
          this.logger.info("forgotPasswordSubmit success");
          AmplifyEventBus.$emit("authState", "signIn");
        })
        .catch((e) => {
          this.sending = false;
          this.setError(e);
        });
    },
    signIn: function() {
      AmplifyEventBus.$emit("authState", "signIn");
    },
    setError: function(e) {
      this.error = this.convertForgotPasswordErrorMessage(e);
      this.logger.error(this.error);
    },
    usernameChanged() {
      // this.$emit('username-field-changed', {usernameField: 'username', username: this.username});
      this.usernameFieldChanged(this.username);
    },
    usernameFieldChanged: function(username) {
      this.forgotPwUsername = username;
    },
  },
};
</script>

<style lang="scss">
.forgot-password-container {
  width: 100vw;
  background: #ffffff;
  padding: 3rem;
  color: var(--purple);

  .desktop & {
    width: 552px;
    box-shadow: 0px 0px 20px #00000029;
    border-radius: 25px;
  }

  .logo {
    height: 3rem;
    margin-bottom: 2rem;
    display: flex;
    justify-content: center;

    img {
      object-fit: contain;
    }
  }

  .title {
    margin-bottom: 1rem;
    font-weight: 600;
    text-align: center;
  }

  .form-input {
    margin-bottom: 1rem;

    .label {
      margin-bottom: 0.5rem;
    }

    input[type="text"],
    input[type="password"],
    input[type="date"] {
      width: 100%;
      height: 40px;
      border-radius: 20px;
      border: solid 1px var(--purple);
      padding: 0 16px;
      font-size: 16px;
      outline: none;
    }

    input[type="text"]:focus,
    input[type="password"]:focus,
    input[type="date"]:focus {
      background: var(--purple-tertiary);
    }

    .input-note {
      padding: 0.5rem 0 0 1rem;
      font-size: 80%;
    }
  }

  .actions {
    margin-top: 3rem;
    display: flex;
    align-items: center;
    flex-direction: column;

    .desktop & {
      margin-top: 4rem;
      justify-content: space-between;
      flex-direction: row-reverse;
    }

    &.disable {
      cursor: none;
      pointer-events: none;
      opacity: 0.5;
    }

    .nav {
      display: flex;
      justify-content: start;
      align-items: center;
      color: #1a82b7;
      cursor: pointer;

      .mobile & {
        margin-top: 3rem;
      }

      a:active {
        opacity: 0.5;
      }
    }

    .submit {
      .button {
        display: flex;
        justify-content: center;
        align-items: center;
        background: var(--purple);
        min-width: 140px;
        height: 44px;
        border-radius: 22px;
        color: #fff;
        padding: 0 1rem;
        cursor: pointer;

        &:active {
          opacity: 0.7;
        }
        &.disable {
          cursor: none;
          pointer-events: none;
          opacity: 0.5;
        }
      }
    }
  }
}
</style>
